// removed by extract-text-webpack-plugin
module.exports = {"result":"antd-pro_-_-scaffold-src-components-Result-result","icon":"antd-pro_-_-scaffold-src-components-Result-icon","success":"antd-pro_-_-scaffold-src-components-Result-success","error":"antd-pro_-_-scaffold-src-components-Result-error","title":"antd-pro_-_-scaffold-src-components-Result-title","description":"antd-pro_-_-scaffold-src-components-Result-description","extra":"antd-pro_-_-scaffold-src-components-Result-extra","actions":"antd-pro_-_-scaffold-src-components-Result-actions"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Result/index.less
// module id = 439
// module chunks = 0 1